"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtOrderState = void 0;
/**
 * @deprecated Use BtOrderState2 instead.
 */
var BtOrderState;
(function (BtOrderState) {
    BtOrderState["CREATED"] = "created";
    BtOrderState["EXPIRED"] = "expired";
    BtOrderState["OPEN"] = "open";
    BtOrderState["CLOSED"] = "closed";
})(BtOrderState = exports.BtOrderState || (exports.BtOrderState = {}));
//# sourceMappingURL=BtOrderState.js.map